import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { CatalogIndexPage } from '@backstage/plugin-catalog/alpha';
import { customCatalogColumns } from './components/catalog/catalogColumns';
import { catalogPlugin } from '@backstage/plugin-catalog';
import {
  componentOverviewLayout,
  // Main column cards — registration order = render order
  aboutCard,
  serviceStatusCard,
  apisCard,
  relationsCard,
  // Right rail cards
  metadataCard,
  linksCard,
  dependenciesCard,
  tagsCard,
} from './components/catalog/ComponentOverview';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/catalog',
        loader: async () => (
          <CatalogIndexPage
            columns={customCatalogColumns}
            initiallySelectedFilter="all"
            tableOptions={{ pageSize: 50, emptyRowsWhenPaging: false }}
          />
        ),
        routeRef: catalogPlugin.routes.catalogIndex,
      },
    }),

    // Redesigned overview layout for all catalog entity kinds.
    componentOverviewLayout,

    // Content cards (main column) — order matters
    aboutCard,
    serviceStatusCard,
    apisCard,
    relationsCard,

    // Info cards (right rail) — order matters
    metadataCard,
    linksCard,
    dependenciesCard,
    tagsCard,
  ],
});
